import React from 'react';
import { Link } from 'react-router-dom';
import { 
  IoGameController, 
  IoMailOutline, 
  IoPhonePortraitOutline, 
  IoStarOutline 
} from 'react-icons/io5';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">
            <IoGameController className="footer-brand-icon" />
            AI Game Show
          </h3>
          <p className="footer-description">
            Revolutionary trivia game where points are awarded based on matching answers. 
            Think strategically about what others might answer!
          </p>
        </div>

        <div className="footer-section">
          <h4>How It Works</h4>
          <ul className="footer-links">
            <li>Answer questions freely</li>
            <li>Match with other players</li>
            <li>More matches = more points</li>
            <li>Strategy meets knowledge</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Game Features</h4>
          <ul className="footer-links">
            <li>AI-Generated Questions</li>
            <li>Real-time Scoring</li>
            <li>Daily Leaderboards</li>
            <li>Admin Dashboard</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Connect</h4>
          <div className="footer-links">
            <div className="social-links">
              <Link to="/contact" className="social-link">
                <IoMailOutline className="social-icon" />
                Contact
              </Link>
              <Link to="/support" className="social-link">
                <IoPhonePortraitOutline className="social-icon" />
                Support
              </Link>
              <Link to="/feedback" className="social-link">
                <IoStarOutline className="social-icon" />
                Feedback
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {currentYear} AI Game Show. All rights reserved.</p>
          <div className="footer-tech">
            <span>Built with React & Node.js</span>
            <span className="separator">•</span>
            <span>Powered by AI</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 